import React from 'react';
import * as Clad from 'clad';
import styled from 'styled-components';

// Only destructure the names actually used below (all antd re-exports from the
// clad barrel: Form/Row/Col/Input/Checkbox/Radio). The field-type components
// (Datepicker, Timepicker, Frequency, Select*, …) are resolved dynamically via
// `Clad[field.type]` in buildComponent, so they must NOT be named here.
//
// Vite/native-ESM fix (V9): the clad barrel exports FieldsForm (index.js L53)
// BEFORE Datepicker/Timepicker/Frequency/Select* (L61+). FieldsForm imports the
// whole barrel, so destructuring those still-uninitialized live bindings at
// module top-level threw a TDZ ReferenceError ("can't access lexical declaration
// 'Datepicker' before initialization"). Webpack's hoisted `var` exports returned
// `undefined` instead of throwing, hiding the circular-import ordering. The antd
// names are safe (re-exported at barrel L6, before FieldsForm).
const { Form, Row, Col, Input, Checkbox, Radio } = Clad;

const { Item } = Form;
const { TextArea } = Input;
const RadioGroup = Radio.Group;

const RadioStyle = styled(RadioGroup)`
    [type='radio']:checked,
    [type='radio']:not(:checked) {
        position: absolute;
        left: 0;
    }
`;

class FieldsForm extends React.Component {
    render() {
        const { fields, record } = this.props;
        const { getFieldDecorator } = this.props.form;

        const cleanPropertiesField = field => {
            const cleanedField = Object.assign({}, { ...field });
            delete cleanedField.value;
            delete cleanedField.id;
            delete cleanedField.type;
            return cleanedField;
        };

        const buildComponent = field => {
            let cleanedField = cleanPropertiesField(field);
            switch (field.type) {
                case 'TextArea':
                    return <TextArea {...cleanedField} />;
                case 'Checkbox':
                    return (
                        <Checkbox {...cleanedField}>
                            {field.labelRight}
                        </Checkbox>
                    );
                case 'RadioGroup':
                    return <RadioStyle {...cleanedField} />;
                case 'CheckboxGroup': {
                    return <Checkbox.Group {...cleanedField} />;
                }
                default: {
                    const Component = Clad[field.type];
                    return <Component {...cleanedField} />;
                }
            }
        };

        const getPropertiesDecorator = field => {
            const commonProperties = {
                initialValue: record[field.id] || field.value,
                rules: field.rules
            };

            switch (field.type) {
                case 'Checkbox':
                    return Object.assign(
                        { valuePropName: 'checked' },
                        { ...commonProperties }
                    );
                default:
                    return commonProperties;
            }
        };

        const setColumn = fields => {
            const columns = [];
            fields.forEach((field, i) => {
                columns.push(
                    <Col key={i} span={field.span || 24}>
                        <Item label={field.label}>
                            {getFieldDecorator(
                                field.id,
                                getPropertiesDecorator(field)
                            )(buildComponent(field))}
                        </Item>
                    </Col>
                );
            });
            return columns;
        };

        const setRow = (Columns, index) => <Row key={index}>{Columns}</Row>;

        const buildForm = () => {
            const rows = [];
            fields.forEach((field, i) => {
                const fieldsColumn = !Array.isArray(field) ? [field] : field;
                const columns = setColumn(fieldsColumn);
                rows.push(setRow(columns, i));
            });
            return rows;
        };

        return <React.Fragment> {buildForm()} </React.Fragment>;
    }
}

export default FieldsForm;
